import * as React from 'react'
import * as Lightbox from 'react-image-lightbox'

import './gallery.css'

export default class Gallery extends React.Component<any, any>  {
  constructor(props: any) {
    super(props)
    
    this.state = {
      photoIndex: 0,
      isOpen: false,
      images: props.images,
    };
  }

  public render() {
    const { photoIndex, isOpen, images } = this.state;

    return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          flexWrap: 'wrap',
        }}>
          {
            images.map((image : Element , i : number) =>
            // tslint:disable
            <img key={i} className="gal-item" src={this.state.images[i]} width="155" height="155" onClick={() => this.setState({ photoIndex: i, isOpen: true })}/>)
          }
          
          {isOpen && (
            // tslint:disable
            <Lightbox
              mainSrc={images[photoIndex]}
              nextSrc={images[(photoIndex + 1) % images.length]}
              prevSrc={images[(photoIndex + images.length - 1) % images.length]}
              onCloseRequest={() => this.setState({ isOpen: false })}
              onMovePrevRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + images.length - 1) % images.length
                })}
              onMoveNextRequest={() =>
                this.setState({
                  photoIndex: (photoIndex + 1) % images.length
                })}
            />
          )}
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/gallery.tsx